import React from "react";
import PropTypes from "prop-types";

import { colorsDef } from "../utilities/colors";
import { textProps, textClass } from "../utilities/text";
import { colorsProps, colorsClass } from "../utilities/colors";
import { sizingProps, sizingClass } from "../utilities/sizing";
import { spacingProps, spacingClass } from "../utilities/spacing";
import { flexProps, flexClass } from "../utilities/flex";

import cn from "classnames";

const AccordionHeader = (props) => {
  let {
    tag: Tag,
    id,
    parent,
    className,
    children,
    onClick,
    ...attributes
  } = props;

  let colors, sizing, spacing, text, flex;
  [text, attributes] = textClass(attributes);
  [colors, attributes] = colorsClass(attributes);
  [sizing, attributes] = sizingClass(attributes);
  [spacing, attributes] = spacingClass(attributes);
  [flex, attributes] = flexClass(attributes);

  return (
    <Tag
      {...attributes}
      className="accordion-collapse collapse"
      onClick={onClick}
      id={`accordion-body-${id}`}
      aria-labelledby={`header-${id}`}
      data-bs-parent={`#accordion-${parent}`}
    >
      <div
        className={cn(
          "accordion-body",
          flex,
          text,
          sizing,
          spacing,
          colors,
          className
        )}
      >
        {children}
      </div>
    </Tag>
  );
};

AccordionHeader.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.oneOf([...colorsDef]),
  id: PropTypes.string.isRequired,
  parent: PropTypes.string.isRequired,
  ...textProps(),
  ...sizingProps(),
  ...colorsProps(),
  ...spacingProps(),
  ...flexProps(),
};

AccordionHeader.defaultProps = {
  tag: "div",
  className: "",
};

export default AccordionHeader;
